import {  Component, ElementRef, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';


import { 
  SharedDataService,
  SuppliersService,
  LoggedUserService,
  Supplier,
  SupplierPurchaseComment,
  Contact,
  ContactsService
 } from 'ngx-paf-common';

@Component({
  selector: 'commentaire-achats',
  templateUrl: './commentaire-achats.component.html',
  styleUrls: ['./commentaire-achats.component.scss']
})
export class CommentaireAchatsComponent implements OnInit,OnChanges {


  constructor(
    public sharedDataSvc:SharedDataService,
    public contactsSvc:ContactsService
    ) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['commentaire']){
      this.topComment = (this.commentaire?.Id||0)>0;
      if (this.commentaire?.CreaContactId) {
        this.contactsSvc.getContact(this.commentaire?.CreaContactId)
        .subscribe(res=>this.creaContact=res);
      }
    }
    if (changes['readonly'] && this.readonly===false){
      if (!this.topComment) this.topComment=true;
    }
  }

  ngOnInit(): void {
  }

  @Input() commentaire: SupplierPurchaseComment;
  @Input() readonly:boolean;
  @Output()  addComment:EventEmitter<SupplierPurchaseComment>= new EventEmitter<SupplierPurchaseComment>();
  @Output()  delComment:EventEmitter<SupplierPurchaseComment> = new EventEmitter<SupplierPurchaseComment>();

  creaContact? : Contact = null;
  private _topComment: boolean = false;
  public get topComment():boolean{
    return this._topComment;
  }
public set topComment(value:boolean) {
  if (value!=this._topComment){
    if (!value && (this.commentaire.Id||0)!=0) {
      this.sharedDataSvc.confirm('Supprimer le commentaire?',
      ():void=>{
        this.delComment.emit(this.commentaire);
      }, null);
      return;
    }
    this._topComment = value;
  }
}
  get commentaireDisabled():boolean {
    if (!this.commentaire || this.readonly) return true;
    return (this.commentaire.Id||0)>0;
  }

  get canAdd():boolean {    
    if (!this.commentaire || this.readonly) return false;
    return (this.commentaire.Id||0)==0 && (this.commentaire.Comment||'').trim()!='';
  }

  public btnAddComment():void {
    this.addComment.emit(this.commentaire);
  }

  public removeComment(){
    this.topComment = false;
  }
}
